export default __webpack_public_path__ + "static/media/Background.c5a9fd6b.png";